var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6020_1533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.0458984C8.19375 0.0458984 7.125 1.11465 7.125 2.4209V35.6709C7.125 36.9771 8.19375 38.0459 9.5 38.0459H33.25C34.5562 38.0459 35.625 36.9771 35.625 35.6709V9.5459L26.125 0.0458984H9.5Z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 9.5459H35.625L26.125 0.0458984V7.1709C26.125 8.47715 27.1938 9.5459 28.5 9.5459Z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.625 16.6709L28.5 9.5459H35.625V16.6709Z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.875 30.9209C30.875 31.574 30.3406 32.1084 29.6875 32.1084H3.5625C2.90938 32.1084 2.375 31.574 2.375 30.9209V19.0459C2.375 18.3928 2.90938 17.8584 3.5625 17.8584H29.6875C30.3406 17.8584 30.875 18.3928 30.875 19.0459V30.9209Z",
    fill: "#F15642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55078 22.5451C7.55078 22.2316 7.79778 21.8896 8.19559 21.8896H10.3889C11.6239 21.8896 12.7354 22.7161 12.7354 24.3003C12.7354 25.8013 11.6239 26.6373 10.3889 26.6373H8.80359V27.8913C8.80359 28.3093 8.53759 28.5456 8.19559 28.5456C7.88209 28.5456 7.55078 28.3093 7.55078 27.8913V22.5451ZM8.80359 23.0855V25.451H10.3889C11.0254 25.451 11.5289 24.8893 11.5289 24.3003C11.5289 23.6365 11.0254 23.0855 10.3889 23.0855H8.80359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5959 28.545C14.2824 28.545 13.9404 28.374 13.9404 27.9572V22.5636C13.9404 22.2228 14.2824 21.9746 14.5959 21.9746H16.7702C21.1094 21.9746 21.0144 28.545 16.8557 28.545H14.5959ZM15.1944 23.1336V27.3872H16.7702C19.3341 27.3872 19.4481 23.1336 16.7702 23.1336H15.1944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5527 23.2098V24.7191H24.974C25.316 24.7191 25.658 25.0611 25.658 25.3924C25.658 25.7059 25.316 25.9624 24.974 25.9624H22.5527V27.9563C22.5527 28.2888 22.3164 28.5441 21.9839 28.5441C21.5659 28.5441 21.3105 28.2888 21.3105 27.9563V22.5626C21.3105 22.2218 21.567 21.9736 21.9839 21.9736H25.3172C25.7352 21.9736 25.9822 22.2218 25.9822 22.5626C25.9822 22.8666 25.7352 23.2086 25.3172 23.2086H22.5527V23.2098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6875 32.1084H7.125V33.2959H29.6875C30.3406 33.2959 30.875 32.7615 30.875 32.1084V30.9209C30.875 31.574 30.3406 32.1084 29.6875 32.1084Z",
    fill: "#CAD1D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6020_1533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(0 0.0458984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.94e9569de5fc0e51e8849184a2558011.svg";
export { ForwardRef as ReactComponent };